import { Checkbox, Form, FormInstance } from "antd";
import React from "react";
import { SelectFromReference } from "src/components/SelectFromReference";
import { edAttrField } from "src/pages/ManagementPage/Obj2Tab/EdAttribute";
import { loadAllObjectAttsOptions } from "../../loadAllObjectAttsOptions";
import { edCompField } from "../ParamsEditorInfo2";
import { MultipleChoiceIteratorDepend } from "./common";

type Props = {
  form: FormInstance;
};

export const ObjectRefEdProps: React.FC<Props> = ({ form }) => {
  const refId = Form.useWatch(edAttrField.referenceId);
  const createButtonAvailable = Form.useWatch(
    edCompField("isCreateButtonAvailable"),
  );
  React.useEffect(() => {
    if (!createButtonAvailable) {
      form.setFieldValue(edCompField("useModal"), false);
    }
  }, [createButtonAvailable]);
  return (
    <>
      <Form.Item
        noStyle
        name={edCompField("isCreateButtonAvailable")}
        valuePropName="checked"
      >
        <Checkbox>Отобразить кнопку Создать</Checkbox>
      </Form.Item>
      <Form.Item noStyle name={edCompField("useModal")} valuePropName="checked">
        <Checkbox disabled={!createButtonAvailable}>
          Создавать экземпляр в модальном окне
        </Checkbox>
      </Form.Item>
      <MultipleChoiceIteratorDepend form={form} />
      <Form.Item
        label="Атрибуты для отображения"
        name={edCompField("labelAtts")}
        rules={[{ required: true }]}
      >
        <SelectFromReference
          loader={() => loadAllObjectAttsOptions(refId)}
          mode="multiple"
          maxTagCount="responsive"
        />
      </Form.Item>
    </>
  );
};
